/* chartAxis.js -- THE ALL-ZERO AXIS (2026-11-03; diffs/runway-arr-tiles-build.txt). ONE owner for the y-axis props of a chart
 * whose plotted series are all zero.
 *
 * Measured (recharts 3.7, real rendering): with every value 0 the default domain gives five ticks that all format to the same
 * label ("$0K" x5 on Scenarios' Total ARR chart). flatZeroAxis(rows, keys) returns { domain: [0, 1], ticks: [0] } -- ONE tick at
 * 0 -- when no row carries a nonzero, finite number under any key; otherwise {} (nothing added), so a chart with data renders
 * exactly as before. `keys` are data keys or accessor functions (row => value). Spread it onto <YAxis>. */
export function flatZeroAxis(rows, keys) {
  const ks = keys || [];
  for (const r of rows || []) {
    for (const k of ks) {
      const v = typeof k === 'function' ? k(r) : (r ? r[k] : undefined);
      if (typeof v === 'number' && Number.isFinite(v) && v !== 0) return {};
    }
  }
  return { domain: [0, 1], ticks: [0] };
}
